import React from 'react';
import { AppstoreOutlined, TableOutlined } from '@ant-design/icons';

import type { MarketsExperience } from './model';

type Props = {
  value: MarketsExperience;
  onChange: (value: MarketsExperience) => void;
  inverse?: boolean;
};

const ExperienceToggle: React.FC<Props> = ({
  value,
  onChange,
  inverse = false,
}) => (
  <div
    className={`markets-v2-toggle${inverse ? ' markets-v2-toggle--inverse' : ''}`}
    role="group"
    aria-label="Markets view"
  >
    <button
      type="button"
      className={value === 'classic' ? 'is-active' : ''}
      aria-label="Classic"
      aria-pressed={value === 'classic'}
      onClick={() => onChange('classic')}
    >
      <TableOutlined />
      Classic
    </button>
    <button
      type="button"
      className={value === 'board' ? 'is-active' : ''}
      aria-label="All markets"
      aria-pressed={value === 'board'}
      onClick={() => onChange('board')}
    >
      <AppstoreOutlined />
      All markets
    </button>
  </div>
);

export default ExperienceToggle;
